/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var c;!function(c){c[c.Occluded=0]="Occluded",c[c.NotOccluded=1]="NotOccluded",c[c.Both=2]="Both",c[c.COUNT=3]="COUNT"}(c||(c={}));export{c as HUDRenderStyle};
